import script from "./CellContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./CellContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./CellContextMenu.vue?vue&type=style&index=0&id=0b4cd66e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b4cd66e"]])

export default __exports__